exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":root{--main-font:normal 11px Verdana}#app,body,html{height:100%;margin:0;overflow:hidden;padding:0;width:100%}body.resizing{user-select:none!important}body.resizing *{pointer-events:none}body.resizing.col{cursor:col-resize!important}", ""]);

